/**
 * Share button component for meeting detail
 */

import {useState} from 'react';
import {Button} from '../ui/Button';
import {cn} from '../../utils/cn';

interface ShareButtonProps {
  meetingTitle: string;
  meetingUrl: string;
  className?: string;
}

export function ShareButton({meetingTitle, meetingUrl, className}: ShareButtonProps) {
  const [isSharing, setIsSharing] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  const handleShare = async () => {
    setIsSharing(true);
    setShowSuccess(false);

    try {
      const shareData = {
        title: meetingTitle,
        text: `Check out this meeting: ${meetingTitle}`,
        url: meetingUrl,
      };

      // Try Web Share API first (mobile/desktop with support)
      if (navigator.share && navigator.canShare && navigator.canShare(shareData)) {
        await navigator.share(shareData);
        setShowSuccess(true);
        setTimeout(() => setShowSuccess(false), 3000);
      } else {
        // Fallback to clipboard
        await navigator.clipboard.writeText(meetingUrl);
        setShowSuccess(true);
        setTimeout(() => setShowSuccess(false), 3000);
      }
    } catch (error: any) {
      // User cancelled share or clipboard failed
      if (error.name !== 'AbortError') {
        console.error('Failed to share:', error);
        // Try clipboard as final fallback
        try {
          await navigator.clipboard.writeText(meetingUrl);
          setShowSuccess(true);
          setTimeout(() => setShowSuccess(false), 3000);
        } catch (clipboardError) {
          console.error('Failed to copy to clipboard:', clipboardError);
        }
      }
    } finally {
      setIsSharing(false);
    }
  };

  return (
    <div className={cn('relative', className)}>
      <Button
        variant="outline"
        className="w-full justify-center"
        onClick={handleShare}
        disabled={isSharing}
      >
        {isSharing ? (
          'Sharing...'
        ) : showSuccess ? (
          '✓ Copied!'
        ) : (
          <>
            <svg
              className="w-4 h-4 mr-2"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z"
              />
            </svg>
            Share Meeting
          </>
        )}
      </Button>
    </div>
  );
}


